import React, { useEffect } from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const MeasureChartsContent = ({ data }) => {

    const charts = Object.entries(data || {}).map(([unitName, values]) => {

        const safeId = unitName
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[()]/g, '')
            .replace(/\s+/g, '-')
            .replace(/[^\w-]/g, '')
            .toLowerCase();

        return {
            id: `${safeId}-apprehensions`,
            title: `${unitName}`,
            data: values,
            exportTitle: `${unitName !== 'Unidade não informada' ? `Apreensões por ${unitName}` : 'Apreensões não informadas'}`
        };
    });

    useEffect(() => {

        charts.forEach(chart => {

            if (!chart.data?.length) return;

            const labels = [];
            const values = [];

            chart.data.forEach(element => {
                labels.push(ReportUtils.formatText(element.text));
                values.push(Number(element.qty));
            });

            GraphicUtils.barChart(chart.id, values.slice(0, 10), labels.slice(0, 10), false);
            if (labels.length > 0) ReportUtils.createExportableTable(labels, values, chart.exportTitle);
        });

    }, [data]);

    const isDuoChart = (chart) => {
        return (chart?.data?.length || 0) <= 3;
    };

    const renderedCharts = [];

    for (let index = 0; index < charts.length; index++) {

        const currentChart = charts[index];
        const nextChart = charts[index + 1];

        const currentIsDuo = isDuoChart(currentChart);
        const nextIsDuo = nextChart && isDuoChart(nextChart);

        if (currentIsDuo && nextIsDuo) {

            renderedCharts.push(
                <React.Fragment key={currentChart.id}>

                    <div className="row">

                        <div className="chart-report duo-bar-chart">
                            <span className="chart-title">{currentChart.title}{currentChart.data?.length >= 10 ? ' (TOP 10)' : ''}</span>
                            <div className="mt-3" id={currentChart.id}></div>
                        </div>

                        <div className="chart-report duo-bar-chart">
                            <span className="chart-title">{nextChart.title}{nextChart.data?.length >= 10 ? ' (TOP 10)' : ''}</span>
                            <div className="mt-3" id={nextChart.id}></div>
                        </div>

                    </div>

                    { index !== charts.length - 2 &&
                        <div className="chart-divisor"/>
                    }

                </React.Fragment>
            );

            index++;
        }

        else {

            renderedCharts.push(
                <React.Fragment key={currentChart.id}>

                    <div className="chart-report">
                        <span className="chart-title">{currentChart.title}{currentChart.data?.length >= 10 ? ' (TOP 10)' : ''}</span>
                        <div className="mt-3" id={currentChart.id}></div>
                    </div>

                    { index !== charts.length - 1 &&
                        <div className="chart-divisor"/>
                    }

                </React.Fragment>
            );
        }
    }

    return (
        <>
            <div id="measure">

                <div className="report-divisor mb-6">
                    <span className="divisor-title"> APREENSÕES POR UNIDADES DE MEDIDA </span>
                </div>

                {renderedCharts}

            </div>
        </>
    );
};

export default MeasureChartsContent;